import React from "react"
import { useToast } from "~/utils/Toast"

import useFetchResource from "~/hooks/useFetchResource"
import getAppConfig from "~/utils/getAppConfig"
import { apiVenues } from "~/routes"

import PageContainer from "~/library/PageContainer"
import LoadingWrapper from "~/library/LoadingWrapper"
import VenueForm from "~/components/VenueForm"
import Venue from "~/types/Venue"

const VenueSettings = () => {
  const { venueSlug } = getAppConfig()
  const toast = useToast()
  const endpoint = apiVenues.show.path({ venueSlug })
  const { data: venue, isLoading } = useFetchResource<{ venue: Venue }, "venue">(
    endpoint,
    "venue",
    {}
  )

  const handleSubmit = (formValues: Venue) => {
    const data = {
      venueSlug: venueSlug,
      venue: { ...formValues },
    }

    const req = apiVenues.update({ data })
    req.then(() => {
      window.location.replace(`/workspace/${formValues.slug}`)
    })
    req.catch((res) => {
      toast(`Error updating Venue. ${res.body.errors.join(", ")}`, "danger")
    })
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">Edit Venue</h3>
          <LoadingWrapper isLoading={isLoading}>
            <VenueForm onSubmit={handleSubmit} initialValues={venue} isEditing />
          </LoadingWrapper>
        </div>
      </div>
    </PageContainer>
  )
}

export default VenueSettings
